import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { UserListComponent } from './features/users/user-list/user-list.component';
import { UserProfileComponent } from './features/users/user-profile/user-profile.component';
import { UserFormComponent } from './features/users/user-form/user-form.component';

import { ReportsComponent } from './features/reports/reports/reports.component';
import { ProjectsComponent } from './features/reports/projects/projects.component';
import { TimeLogsComponent } from './features/reports/timelogs/timelogs.component';
import { AnalysisComponent } from './features/reports/analysis/analysis.component';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
// import { AuthGuard } from './core/guards/auth.guard'; // Assume generated or create later

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'profile', pathMatch: 'full' },
            {
                path: 'users',
                component: UserListComponent,
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },

            {
                path: 'users/modules',
                loadComponent: () => import('./features/users/module-management/module-management.component').then(m => m.ModuleManagementComponent),
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },
            {
                path: 'reports',
                component: ReportsComponent,
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },
            {
                path: 'reports/projects',
                component: ProjectsComponent,
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },
            {
                path: 'analysis',
                component: AnalysisComponent,
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },
            { path: 'reports/timelogs', component: TimeLogsComponent },
            { path: 'reports/timelogs', component: TimeLogsComponent },
            { path: 'users/new', component: UserFormComponent },
            { path: 'users/:id', component: UserFormComponent },
            { path: 'users/:id', component: UserFormComponent },
            { path: 'profile', component: UserProfileComponent },
            {
                path: 'finance-report',
                loadComponent: () => import('./features/finance-report/finance-report.component').then(m => m.FinanceReportComponent),
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin', 'Finance'] }
            },
            {
                path: 'communication-settings',
                loadComponent: () => import('./features/admin/communication-settings/communication-settings.component').then(m => m.CommunicationSettingsComponent),
                canActivate: [authGuard],
                data: { roles: ['SystemAdmin', 'Admin'] }
            },
        ]
    },
    { path: '**', redirectTo: 'login' }
];
